import { useSyncExternalStore } from 'react';
import { toasterService } from 'services/toaster';
import type { ToasterState } from './types';

export function useToasterState(): ToasterState {
  return useSyncExternalStore(
    toasterService.subscribe,
    toasterService.getSnapshot
  );
}
